import { createContext } from 'react';
import type { ICalendarContext } from './types';

export const CalendarContext = createContext<ICalendarContext>(
  {} as ICalendarContext
);
